import React from "react";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { colors } from "../../theme";

interface ReplyMessageCardProps {
  details?: string;
  activity_type?: string;
  timestamp?: string;
}

const ReplyMessageCard = ({ details, activity_type, timestamp }: ReplyMessageCardProps) => {
  // Debug log to verify props are being passed correctly
  console.log('ReplyCard Data:', { details, activity_type, timestamp });

  // Use details (message) as main text, fallback to activity_type (type) if details is empty
  const mainText = details || activity_type || "No Data";
  const showActivityLabel = details && activity_type; // only show label if both exist

  console.log('ReplyCard mainText:', mainText, 'showActivityLabel:', showActivityLabel);

  return (
    <Paper
      sx={{
        background: colors.white1,
        display: "flex",
        maxWidth: "70%",
        textAlign: "start",
        padding: ".35rem .8rem",
        flexDirection: "column",
        borderRadius: ".625rem",
        position: "relative",

        "&::after": {
          content: '" "',
          border: "20px solid transparent",
          position: "absolute",
          top: 0,
          left: "-1.25rem",
          borderTopLeftRadius: ".5rem",
          borderTopColor: colors.white1,
        },
      }}
    >
      {showActivityLabel && (
        <Typography
          color={colors.black1}
          sx={{
            fontSize: "0.75rem",
            fontWeight: "bold",
            textTransform: "uppercase",
            marginBottom: "0.25rem",
            letterSpacing: "0.5px",
          }}
        >
          {activity_type}
        </Typography>
      )}
      <div style={{ color: "#1e2c32", fontSize: "1rem", display: "block", visibility: "visible" }}>
        {mainText}
      </div>
      <Typography
        color={colors.grey1}
        sx={{
          fontSize: ".85rem",
          display: "flex",
          alignSelf: "flex-end",
          marginTop: "0.25rem",
        }}
      >
        {timestamp || ""}
      </Typography>
    </Paper>
  );
};

export default ReplyMessageCard;
